import { formatDateTime24 } from '../../utils/formatTime24';

export const STATUS_STYLES = {
  COMPLETED: 'bg-green-100 text-green-700',
  FAILED: 'bg-red-100 text-red-700',
  PENDING: 'bg-amber-100 text-amber-700',
  PROCESSING: 'bg-blue-100 text-blue-700',
};

export const formatDateTime = (value) => {
  if (!value) return '---';
  return formatDateTime24(value, { seconds: true });
};
